import { Injectable } from '@angular/core';
import { HttpServices } from './http.service';
import { UserInfoModel } from '../models/userInfo.model';
import { TAB_BAR_STRUCTURE } from '../components/tab-bar/tab-bar-structure';
import * as config from '../config/config';
import { ReferenceService } from '../services/reference.service';
import { NavigationMenuModel, TabbarStructure } from '../models/navigation/navigation-menu.model';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private tabBarData;
  private activableLinks: NavigationMenuModel[];
  private hasAgencySlApp = false;
  private userInfos: UserInfoModel;

  constructor(
    private httpServices: HttpServices,
    private referenceService: ReferenceService) { }

  fetchNavigationApps(): Observable<NavigationMenuModel[]> {
    return this.httpServices.getDuo<NavigationMenuModel[]>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_NAVIGATION],
      () => { });
  }

  fetchUserInfos(): Observable<UserInfoModel> {
    return this.httpServices.getDuo<UserInfoModel>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_USER_INFO],
      () => { });
  }

  setUserInfos(userInfos: UserInfoModel) {
    this.userInfos = userInfos;
  }

  // Fill urls intitems and exclude not wanted items
  filteringTabBar(activableLinks: NavigationMenuModel[]): void {
    this.activableLinks = activableLinks;
    let filteredTabbar: TabbarStructure;
    filteredTabbar = TAB_BAR_STRUCTURE;
    // Keep only authorized items
    filteredTabbar.menu = this.filterNavigationElement(TAB_BAR_STRUCTURE.menu);
    filteredTabbar.help = this.filterNavigationElement(TAB_BAR_STRUCTURE.help);
    filteredTabbar.account = this.filterNavigationElement(TAB_BAR_STRUCTURE.account);

    // Just get correct routes
    filteredTabbar.home.url = window.location.origin;

    this.tabBarData = filteredTabbar;
  }

  fillRoute(element: any, id: string): any {
    const index = this.activableLinks.findIndex(activableLink => id === activableLink.code);
    if (index !== -1) {
      element.url = this.activableLinks[index].app.url;
    }
  }

  filterNavigationElement(element: any): any {
    return element.filter(tabLink => {
      const index = this.activableLinks.findIndex(activableLink => tabLink.id === activableLink.code);
      if (index !== -1) {
        tabLink.url = this.activableLinks[index].app.url;
        return true;
      } else {
        return false;
      }
    });
  }

  getActivableLinksData() {
    return this.activableLinks;
  }

  getTabBarData() {
    return this.tabBarData;
  }

  getUserInfos(): UserInfoModel {
    return this.userInfos;
  }

  getHasAgencySlApp(): boolean {
    return this.hasAgencySlApp;
  }
}
